import React from 'react';
import { Grid, Typography } from '@mui/material';
import { getJsonPath } from '../../utils/constants';

type Props = {
};

const ClientDateTimeErrorComponent = (props: Props) => {
    console.log(props);
    return (
        <Grid container alignItems="center" flexDirection="column" spacing={4}>
            <Grid item>
                <img
                    src={getJsonPath('/Error/time_error.svg')}
                    alt=""
                />
            </Grid>
            <Grid item>
                <Typography
                    textAlign="center"
                    variant="h3"
                >
                    Whoops! Lost in Time?
                </Typography>
                <Typography
                    textAlign="center"
                    variant="h6"
                    component="div"
                    style={{
                        color: 'grey',
                        marginTop: '32px',
                    }}
                >
                    System Date/Time is Wrong.
                    <br />
                    Please set the correct date/time on your system and reload the page.
                </Typography>
            </Grid>
        </Grid>

    );
};

export default ClientDateTimeErrorComponent;
